import { useCallback, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router";

export const useUrlHandler = (param) => {
  const history = useHistory();
  const { code, module, group } = useParams();
  const { search } = useLocation();

  const [value, setValue] = useState('');

  const handleChangeUrlValue = useCallback(
    (newValue) => {
      const urlParams = new URLSearchParams(search);
      urlParams.set(param, newValue);

      history.replace(`/${code}/Report/${module}/${group}?${urlParams}`);
      setValue(newValue);
    },
    [search, param, history, code, module, group]
  );

  return { value, handleChangeUrlValue };
};
